import { atom } from 'jotai';

interface SpluginLoadStatus {
  isComplete: boolean;
  error?: any;
}

export const spluginLoadStatusAtom = atom<SpluginLoadStatus>({ isComplete: false });
